var map = {
	"./answer_box.svg": "c836",
	"./local_3_pack.svg": "e616",
	"./news_pack.svg": "2f8b",
	"./news_pack_results.svg": "b1fb",
	"./people_also_ask.svg": "0b5a",
	"./video_pack.svg": "36a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "93ee";